// Единственное место, где приложение трогает window.Telegram.WebApp.
// initData не логируем и не сохраняем: они уходят только в POST /auth/telegram.

interface TelegramBackButton {
  show: () => void
  hide: () => void
  onClick: (cb: () => void) => void
  offClick: (cb: () => void) => void
}

interface TelegramHaptic {
  notificationOccurred: (type: 'error' | 'success' | 'warning') => void
  impactOccurred: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => void
}

interface TelegramWebApp {
  initData: string
  platform: string
  ready: () => void
  expand: () => void
  openTelegramLink?: (url: string) => void
  BackButton?: TelegramBackButton
  HapticFeedback?: TelegramHaptic
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp }
  }
}

function webApp(): TelegramWebApp | null {
  const app = window.Telegram?.WebApp
  // SDK грузится и вне Telegram: там initData пустые и platform "unknown"
  if (app === undefined || app.initData === '') return null
  return app
}

export function isInTelegram(): boolean {
  return webApp() !== null
}

/** Свежие initData текущего запуска или `null` вне Telegram. */
export function getInitData(): string | null {
  return webApp()?.initData ?? null
}

/** Сообщить Telegram, что интерфейс готов, и развернуть Mini App на весь экран. */
export function signalReady(): void {
  const app = webApp()
  if (app === null) return
  app.ready()
  app.expand()
}

export function haptic(type: 'error' | 'success' | 'warning'): void {
  webApp()?.HapticFeedback?.notificationOccurred(type)
}

/** Кнопка «назад» Telegram; возвращает функцию снятия. Вне Telegram ничего не делает. */
export function showBackButton(onBack: () => void): () => void {
  const button = webApp()?.BackButton
  if (button === undefined) return () => undefined
  button.onClick(onBack)
  button.show()
  return () => {
    button.offClick(onBack)
    button.hide()
  }
}
